export default "__VITE_ASSET__wWr0imc2__"